import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';
import LiftReport from '../entity/LiftReport';

export const startFetchingLiftReports = () =>
  produce((draft: Draft<State>) => {
    draft.liftReports.fetching = draft.liftReports.fetching + 1;
  });

export const setLiftReports = (liftReports: LiftReport[]) =>
  produce((draft: Draft<State>) => {
    draft.liftReports.data = liftReports;
  });

export const finishFetchingLiftReports = () =>
  produce((draft: Draft<State>) => {
    draft.liftReports.fetching = draft.liftReports.fetching - 1;
  });

export const disposeLiftReports = () =>
  produce((draft: Draft<State>) => {
    draft.liftReports.data = initialState.liftReports.data;
    draft.liftReports.fetching = initialState.liftReports.fetching;
  });
